import { render, staticRenderFns } from "./NewsInfos.vue?vue&type=template&id=3ea68e6e&scoped=true&"
import script from "./NewsInfos.vue?vue&type=script&lang=js&"
export * from "./NewsInfos.vue?vue&type=script&lang=js&"
import style0 from "./NewsInfos.vue?vue&type=style&index=0&id=3ea68e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea68e6e",
  null
  
)

export default component.exports